import React, { useEffect, useState } from "react";
import DataDisplayTable from "../../dataDisplayTable";
import { useAllReportsContext } from "../contextProviders/allReportsContext";
import { CLI_V2, PROP, USR } from "../../../shared/Data/typeDirs";
import { Button, Col, Form, Tab, Tabs } from "react-bootstrap";
import { NewControlManager } from "../../newControlManager";
import { DateToFormattedString } from "../../../shared/utils";
import { dataSource } from "../../../services/dataSource";
import typeMap from "../../../shared/Data/typeMap";
import { useAppContainerContext } from "../appContainer/context";
import { ModalContainer } from "../../newControlManager/controlWrappers/containers/modal";

const cols = [
  { accessor: 'dirName', show: false },
  { accessor: '_id', show: false },
  { accessor: 'metadata_users', show: false },
  { accessor: `all_${CLI_V2}`, show: false },
  { Header: 'Name', accessor: 'name' },
  {
    Header: 'Address', accessor: 'address', defaultWidth: 100, Cell: (data) => {
      // console.log('address cell', data)
      return [data.value.streetAddress, data.value.city, data.value.state].join(', ')
    }
  },
  { Header: 'Modified', accessor: 'modified', Cell: getDateForTableCell },
  { Header: 'Modified By', accessor: '_modifiedBy', Cell: (data) => `${data.row.metadata_users?._createdBy?.firstName} ${data.row.metadata_users?._createdBy?.lastName}` },
  { Header: 'Created', accessor: 'created', Cell: getDateForTableCell },
  { Header: 'Created By', accessor: '_createdBy', Cell: (data) => `${data.row.metadata_users?._modifiedBy?.firstName} ${data.row.metadata_users?._modifiedBy?.lastName}` },
]

const client_col = { accessor: '_clients_v2', Header: 'Client', Cell: (data) => data.value ? data.row.all_clients_v2?.find(itm => itm._id === data.value).name : null }

function getDateForTableCell(data) {
  return data.value ? DateToFormattedString(new Date(data.value)) : ''
}


export function PageClientV2(props) {
  const allRepState = useAllReportsContext()
  const { setMenuOptions } = useAppContainerContext()
  const [showEditClientModal, setShowEditClientModal] = useState(false)
  const [newClientData, setNewClientData] = useState({ saved: false })
  // const [filteredState, setFilteredState] = useState({ [CLI_V2]: [], [PROP]: [] })

 

  function initNew(type) {
    let client = new typeMap[type]()
    setNewClientData({ contents: client.getContents(), schemas: client.getSchemas(), source: allRepState, client })
    setShowEditClientModal(true)
  }

  async function saveNewClient({ controls }) {
    const type = newClientData.client.type
    let data = controls[0]
    // console.log('have we got it?', data, type)
    let newClient = new typeMap[type]({ ...newClientData.client, ...data })
    console.log('new Client made', newClient)
    // return
    let res = await dataSource('remDb')[type].put(newClient)
    console.log('saveNewClient, res and newClient', res, newClient)
    if (!newClientData.saved) {
      await allRepState.initAllData()
      setNewClientData({ ...newClientData, client: newClient, contents: newClient.getPhotoContents(), saved: true })
    } else {
      // await allRepState.initAllData()
      setShowEditClientModal(false)
      setNewClientData({})
    }
  }
  props.setTitle('Clients')
  console.log('rendering PageClientV2')

  function editClient(type, _id){
    console.log('attempting client edit', type, _id)
    let client = new typeMap[type](allRepState[type].find(itm=> itm._id === _id ))
    setNewClientData({ contents: client.getContents(), schemas: client.getSchemas(), source: allRepState, client })
    setShowEditClientModal(true)
  }
  return (
    <>
      <Tabs>
        <Tab eventKey={CLI_V2} title="Clients" >
          <ClientDataTable
            tableCols={cols}
            users={allRepState[USR]}
            data={{ [CLI_V2]: allRepState[CLI_V2] }}
            label="Clients"
            type={CLI_V2}
            initNew={initNew} 
            onClick={editClient}
          />
        </Tab>
        <Tab eventKey={PROP} title="Properties">
          <ClientDataTable
            tableCols={[...cols, client_col]}
            users={allRepState[USR]}
            data={{ [CLI_V2]: allRepState[CLI_V2], [PROP]: allRepState[PROP] }}
            label="Properties"
            type={PROP}
            initNew={initNew} 
            onClick={editClient}
          />
        </Tab>
      </Tabs>
      <NewControlManager
        onSubmit={saveNewClient}
        content={newClientData.contents}
        schemas={newClientData.schemas}
        source={newClientData.source}
        objectMetadata={newClientData.client}
        options={{
          modules:{container: ModalContainer}, show: showEditClientModal, setShow: (arg) => {
            setShowEditClientModal(arg)
          }
        }}
      />
    </>
  )
}

function ClientDataTable({ data, label, type, initNew, users, tableCols, onClick }) {
  const [filteredState, setFilteredState] = useState([])
  function onFilterChange(evt) {
    let value = evt.target.value
    let filteredObjects = data[type].filter(
      itm => itm.name.toLowerCase().includes(value.toLowerCase()) || compareFilterToAddress(value, itm.address)
    )
    setFilteredState(filteredObjects || [])
  }

  useEffect(() => {
    console.log('ClientDataTable useEffect [data]', data, type)
    setFilteredState(data[type].map(cli => {
      return {
        ...cli,
        metadata_users: {
          _createdBy: users.find(usr => usr._pid === cli._createdBy),
          _modifiedBy: users.find(usr => usr._pid === cli._modifiedBy)
        },
        [`all_${CLI_V2}`]: data[CLI_V2]
      }
    }))
  }, [data, users, type])


  return (
    <DataDisplayTable
      title={label}
      onClickEntry={(row) => { onClick(type, row.original._id ) }}
      cols={tableCols}
      data={filteredState}
      headerChildren={(
        <>
          <Col className="col-container" sm="3">
            <Button className="property-query-action" variant="outline-info" onClick={() => initNew(type)}>
              Create New
            </Button>
          </Col>
          <Col className="col-container" sm>
            <Form.Control type="text" onChange={onFilterChange} placeholder={`Search ${label}`} />
          </Col>
        </>
      )}
    />
  )
}

function compareFilterToAddress(filter, addressObj) {
  const lowerFilter = filter.toLowerCase()
  return addressObj.streetAddress.toLowerCase().includes(lowerFilter) ||
    addressObj.city.toLowerCase().includes(lowerFilter) ||
    addressObj.state.toLowerCase().includes(lowerFilter)
}